import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useSettingsStore } from '../../';



const useDocumentStore = defineStore('document', () => {
  const data = ref<string>('');
  const { settings } = useSettingsStore();

  function setDocumentTitle(targetTitle?: string) {
    const title = settings.system.getDocumentTitle?.(targetTitle)
    if (title === undefined) {
      return
    }

    document.title = title
    data.value = title
  }

  return {
    data: computed(() => data.value),
    setDocumentTitle,
  };
});

export default useDocumentStore;
